import { from, Observable } from "rxjs";
import { PageRequest } from "src/app/support/page-request";
import { UserNotify } from "src/app/support/notify-decorator";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Injectable } from "@angular/core";
import {
  Mastercase,
  MastercaseCreate,
  MastercaseUpdate
} from "../models/mastercase";
import { HttpClient } from "@angular/common/http";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";

type SearchQueryParams = {
  customerId?: string;
  patientId?: string;
};

@Injectable()
export class MastercaseBackend {
  constructor(private http: HttpClient) {}

  @UserNotify({
    successMessage: marker("Mastercase creato"),
    errorMessage: marker("Impossibile creare il mastercase")
  })
  create(payload: MastercaseCreate): Observable<Mastercase> {
    return this.http.post<Mastercase>(
      `${environment.snoots.api.healthcare}/master-cases`,
      payload
    );
  }

  load(id: string): Observable<Mastercase> {
    return this.http.get<Mastercase>(
      `${environment.snoots.api.healthcare}/master-cases/${id}`
    );
  }

  search({
    customerId,
    patientId
  }: SearchQueryParams): Observable<Mastercase[]> {
    const queryParams: SearchQueryParams = {};

    if (customerId) {
      queryParams.customerId = customerId;
    }

    if (patientId) {
      queryParams.patientId = patientId;
    }

    return this.http
      .get<PaginatedResult<Mastercase>>(
        `${environment.snoots.api.healthcare}/master-cases`,
        {
          params: queryParams
        }
      )
      .pipe(map((x) => x.docs));
  }

  list(request: PageRequest): Observable<PaginatedResult<Mastercase>> {
    return this.http.get<PaginatedResult<Mastercase>>(
      `${environment.snoots.api.healthcare}/master-cases`
    );
  }

  @UserNotify({
    successMessage: marker("Mastercase aggiornato"),
    errorMessage: marker("Impossibile aggiornare il mastercase")
  })
  update(id: string, payload: MastercaseUpdate): Observable<void> {
    return this.http.patch<void>(
      `${environment.snoots.api.healthcare}/master-cases/${id}`,
      payload
    );
  }

  @UserNotify({
    successMessage: marker("Mastercase rimosso"),
    errorMessage: marker("Impossibile rimuovere il mastercase")
  })
  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.snoots.api.healthcare}/master-cases/${id}`
    );
  }
}
